import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import Flex from 'components/Flex';
import TooltipButton from 'components/TooltipButton';
import { CommentSizesContext } from '../Context';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CommentFormTitleBar(_ref) {
  var title = _ref.title,
    _ref$isNested = _ref.isNested,
    isNested = _ref$isNested === void 0 ? false : _ref$isNested,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var size = useContext(CommentSizesContext);
  return /*#__PURE__*/_jsxs(Flex, {
    mb: "xxxs",
    align: "center",
    ml: isNested ? 76 : 42,
    children: [/*#__PURE__*/_jsx(Box, {
      grow: true,
      shrink: true,
      bold: true,
      mr: "xs",
      fontSize: size === 'DEFAULT' ? 'xs' : ['xs', 'm'],
      breakpoints: "m",
      overflow: "ellipsis",
      children: title
    }), /*#__PURE__*/_jsx(TooltipButton, {
      icon: "x",
      size: "small",
      variant: "transparent",
      title: t('actions_cancel'),
      onClick: onClose
    })]
  });
}
export default CommentFormTitleBar;